import React from 'react';
import profiles from '../data/profiles.json';

class ProfileSlider extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            profiles: this.props.profiles||[]
        };
    }
    
    static defaultProps = {
        carouselId: "sliderProfiles",
        carouselInterval: 5000,
        carouselButtonClasses: "btn btn-light btn-sm ml-2",
        heading: "Latest Profiles",
        profiles: profiles,
        className: "",
        likesLink: "./",
        friendsLink: "./",
        postsLink: "./",
        headerClasses: "",
        contentClasses: "text-center",
        countClasses: "text-center"
    };

    render(){
        var { profiles } = this.state;
        return (
            <div className={'card shadow-sm rounded-lg wow zoomIn ' + this.props.className}>
                <div className={'card-header ' + this.props.headerClasses}>
                    <div className="row align-items-center">
                        <div className="col-sm">
                            <h4 className="font-weight-light mb-0">{ this.props.heading }</h4>
                        </div>
                        <div className="col-sm-auto ml-auto">
                            <button className={this.props.carouselButtonClasses} data-target={'#' + this.props.carouselId} data-slide="prev">
                                <span className="fa fa-chevron-left align-middle icons icon-arrow-left" aria-hidden="true"></span>
                                <span className="sr-only">Previous</span>
                            </button>
                            <button className={this.props.carouselButtonClasses} data-target={'#' + this.props.carouselId} data-slide="next">
                                <span className="fa fa-chevron-right align-middle icons icon-arrow-right" aria-hidden="true"></span>
                                <span className="sr-only">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div id={this.props.carouselId} className="carousel slide my-auto w-100" data-ride="carousel" data-interval={this.props.carouselInterval}>
                    <div className="carousel-inner rounded-lg" role="listbox">
                    {
                        profiles && profiles.length > 0 ? profiles.map((item,key) =>
                        (<div className={(key===0)?'carousel-item active':'carousel-item'} key={key}>
                            <div className="card rounded-lg border-0">
                                <div className="row align-items-center no-gutters">
                                    <div className="col-md-4 col-lg-4 col-xl-4 col-12">
                                        <div className="w-100 p-3">
                                            <img className="rounded-circle img-fluid mx-auto d-block bg-light" src={item.pic} alt="profile pic" />
                                        </div>
                                    </div>
                                    <div className="col-md-8 col-lg-8 col-xl-8 col-12">
                                        <div className={'card-body ' + this.props.contentClasses}>
                                            <h3 className="mb-0">{item.name}</h3>
                                            <span className="text-muted font-weight-normal">@{item.username}</span>
                                            <p className="mt-1 text-truncate">{item.short}</p>
                                            <div className="row">
                                                <div className={'col-12 ' + this.props.countClasses}>
                                                    <div className="row">
                                                        <div className="col-4 py-1">
                                                            <h4 className="mb-0 text-truncate">{item.likes}</h4>
                                                            <a href={this.props.likesLink} className="d-block small text-uppercase text-truncate">likes</a>
                                                        </div>
                                                        <div className="col-4 border-left border-right py-1">
                                                            <h4 className="mb-0 text-truncate">{item.posts}</h4>
                                                            <a href={this.props.postsLink} className="d-block small text-uppercase text-truncate">posts</a>
                                                        </div>
                                                        <div className="col-4 py-1">
                                                            <h4 className="mb-0 text-truncate">{item.friends}</h4>
                                                            <a href={this.props.friendsLink} className="d-block small text-uppercase text-truncate">friends</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )):''}
                    </div>
                </div>
            </div>
        );
    }
}

export default ProfileSlider;